import React from "react";

const NotFoundPage = () => {
  return (
    <>
      <div>
        <h1>Fehler: 404 Nicht gefunden</h1>
        <p>Die gesuchte Seite existiert nicht!</p>
      </div>
    </>
  );
};

export default NotFoundPage;
